function init() {
  setTimeout(() => {
    var scriptDefer = document.getElementsByTagName('script');
    for (var i = 0; i < scriptDefer.length; i++) {
      if (scriptDefer[i].getAttribute('data-src')) {
        scriptDefer[i].setAttribute('src', scriptDefer[i].getAttribute('data-src'));
      }
    }
  }, 1000);
}
$(window).on('load', init);